// extracted by mini-css-extract-plugin
export var content = "terms-module--content--3Iy6v";
export var block = "terms-module--block--1V3Tz";
export var title = "terms-module--title--6ntuo";
export var text = "terms-module--text--3U6TO";